import * as React from "react";
import { Col, ControlLabel, FormGroup } from "components/bootstrap";
import TypeSpecificParameterInput from "enterprise/parameters/components/TypeSpecificParameterInput";
const ParameterInput = ({ parameter, value, onChange, searchId, onBlur }) => {
  const { name, title } = parameter;
  return /* @__PURE__ */ React.createElement(FormGroup, { key: `parameter-${name}`, controlId: `parameter-${name}` }, /* @__PURE__ */ React.createElement(Col, { componentClass: ControlLabel, sm: 3 }, title), /* @__PURE__ */ React.createElement(Col, { sm: 9 }, /* @__PURE__ */ React.createElement(
    TypeSpecificParameterInput,
    {
      parameter,
      value,
      onChange,
      onBlur,
      searchId
    }
  )));
};
export default ParameterInput;
